import { createSeededRandomNumberGenerator } from "@iventis/utilities";
import { formatCoordinateForSeed } from "./normalise-coordinate";

const FULL_ROTATION_DEGREES = 360;

/**
 * Creates a deterministic pseudo-random rotation from a map coordinate.
 *
 * The same coordinate will always return the same value.
 *
 * @param coordinate Coordinate as [longitude, latitude].
 * @returns Deterministic pseudo-random number in the range [0, 360).
 */
export function getSeededRandomDegreesFromCoordinate(coordinate: [number, number]): number {
    const random = createSeededRandomNumberGenerator(formatCoordinateForSeed(coordinate));

    return random() * FULL_ROTATION_DEGREES;
}
